import { Box, IconButton } from "@mui/material"
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

export const InfoIconFieldSelector = ({onClick}: {onClick: () => void}) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <IconButton onClick={onClick}>
                <InfoOutlineIcon sx={{ color: 'primary.main' }} />
            </IconButton>
        </Box>
    )
}